"use client";
import React from "react";

interface BadgeProps {
  iconUrl: string;
  label: string;
  backgroundColor: string;
}

const AchievementBadge: React.FC<BadgeProps> = ({ iconUrl, label, backgroundColor }) => {
  return (
    <div
      className={`flex flex-col px-3 py-5 ${backgroundColor} rounded-xl h-[81px] w-[81px]`}
    >
      <img
        src={iconUrl}
        alt={label}
        className="object-contain self-center aspect-[0.75] w-[18px]"
      />
      <span className="py-px mt-1 bg-black bg-opacity-0">{label}</span>
    </div>
  );
};

export default AchievementBadge;
